import GTM from "~/utils/classes/Gtm";

export default {
  data(){
    return {
      gtm: new GTM(this.$gtm)
    }
  }
}
